import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, Output, SimpleChanges } from '@angular/core';
import {FormControl, FormGroup, FormBuilder} from '@angular/forms';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import config from 'config/default.json';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
@Component({
  selector: 'app-vca-filter',
  templateUrl: './vca-filter.component.html',
  styleUrls: ['./vca-filter.component.scss']
})
export class VcaFilterComponent {
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    private apiService: ApiServiceModule,
    private helper: HelperModule,
    private sharedService: SharedService,
    private zone: NgZone
    ) {}
  countryControl = new FormControl();
  institutionControl = new FormControl();
  structureControl = new FormControl();
  cycleControl = new FormControl();
  departmentControl = new FormControl();
  modeControl = new FormControl();
  searchControl = new FormControl();

  countries: { [x:string]: string|number|boolean }[] = [];
  institutions: { [x:string]: string|number|boolean }[] = [];
  structures: { [x:string]: string|number|boolean }[] = [];
  cycles: { [x:string]: string|number|boolean }[] = [];
  departments: { [x:string]: string|number|boolean }[] = [];

  selectedCountry: any[] = [];
  selectedInstitutions: any[] = [];
  selectedStructures: any[] = [];
  selectedCycle: any = null;
  selectedDepartments: any[] = [];

  searchCountryControl = new FormControl();
  searchInstitutionControl = new FormControl();
  searchStructureControl = new FormControl();
  searchCycleControl = new FormControl();
  searchDepartmentControl = new FormControl();

  filteredCountries: { [x:string]: string|number|boolean }[] = [];
  filteredInstitutions: { [x:string]: string|number|boolean }[] = [];
  filteredStructures: { [x:string]: string|number|boolean }[] = [];
  filteredCycles: { [x:string]: string|number|boolean }[] = [];
  filteredDepartments: { [x:string]: string|number|boolean }[] = [];

  userFilter: any = new Map();
  lastTable!:string;
  
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() modes:any[] = [];

  @Input() pageId!: string;
  @Input() pageName?: string | undefined;
  @Input() hasSearchKey?: boolean | undefined;
  @Input() platformInfos:any;
  @Output() filterDataOutputEvent = new EventEmitter<any>();
  showDepartment!: boolean;

  ngOnInit(){
    this.fillFilter();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userInfos'] && !changes['userInfos'].firstChange) {
      this.fillFilter();
      this.cdRef.detectChanges();
    }
  }
  fillFilter(){
    this.showDepartment = ['vca-upload-content', 'vca-dashboard'].includes(this.pageId)? false: true;
    let userNavigationInfos = this.userInfos['navigation_infos'];
    this.userFilter = userNavigationInfos && userNavigationInfos["vca_filter_"+this.pageId]? userNavigationInfos["vca_filter_"+this.pageId]: {};

    this.userFilter['key_update'] = "vca_filter_"+this.pageId;
    this.userFilter['id_user'] = this.userInfos['id_user'];
    this.userFilter['id_country'] = this.userFilter.country || null;
    this.userFilter['id_cycle'] = this.userFilter.cycle || null;
    this.lastTable = this.userFilter['last_table'];
    this.selectedCountry = this.userFilter['id_country'];
    this.selectedInstitutions = this.userFilter['vca_institution']? this.userFilter['vca_institution']: [];
    this.selectedStructures = this.userFilter['structure']? this.userFilter['structure']: [];
    this.selectedCycle = this.userFilter['id_cycle'];
    this.selectedDepartments = this.userFilter['department']? this.userFilter['department']: [];
    this.modeControl.setValue(this.userFilter.mode || null);
    
    this.applySearch();
    this.loadCountry();
  }
  applySearch(){
    this.searchCountryControl.valueChanges.subscribe((text) => {
      return this.filteredCountries = this.countries.filter(element => this.normalizeString(`${element['name']} ${element['full_name']}`).includes(this.normalizeString(text)));
    });
    this.searchInstitutionControl.valueChanges.subscribe((text) => {
      return this.filteredInstitutions = this.institutions.filter(element => this.normalizeString(`${element['name']} ${element['full_name']}`).includes(this.normalizeString(text)));
    });
    this.searchStructureControl.valueChanges.subscribe((text) => {
      return this.filteredStructures = this.structures.filter(element => this.normalizeString(`${element['name']} ${element['full_name']}`).includes(this.normalizeString(text)));
    });
    this.searchCycleControl.valueChanges.subscribe((text) => {
      return this.filteredCycles = this.cycles.filter(element => this.normalizeString(`${element['name']} ${element['full_name']}`).includes(this.normalizeString(text)));
    });
    this.searchDepartmentControl.valueChanges.subscribe((text) => {
      return this.filteredDepartments = this.departments.filter(element => this.normalizeString(`${element['name']} ${element['full_name']}`).includes(this.normalizeString(text)));
    });
  }
  normalizeString(str:any){
    return str.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  loadCountry(){
    this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/country', {}, this.userInfos['access_token']).subscribe((response:any)=>{
      this.countries = response;
      this.filteredCountries = this.countries;
      this.institutions = [];
      this.structures = [];
      this.cycles = [];
      this.departments = [];
      this.filteredInstitutions = [];
      this.filteredStructures = [];
      this.filteredCycles = [];
      this.filteredDepartments = [];
      
      this.institutionControl.setValue([]);
      this.structureControl.setValue([]);
      this.departmentControl.setValue([]);
      this.updateInstitution();
      this.selectedCountry = this.countryControl.value ?? this.selectedCountry;
      this.countryControl.setValue(this.selectedCountry);
      console.log(this.selectedCountry)
      if(this.lastTable == 'country') this.chargeData();
    });
  }
  updateInstitution(isUpdate:boolean = false){
    if(isUpdate) this.selectedCountry = this.countryControl.value;
    if(this.selectedCountry){
      this.userFilter.last_table = 'country';
      this.userFilter.id_country = this.selectedCountry;
      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/institution', this.userFilter, this.userInfos['access_token']).subscribe((response:any)=>{
        this.institutions = response;
        this.filteredInstitutions = this.institutions;
        if(isUpdate) this.lastTable = this.userFilter.last_table;
        this.selectedInstitutions = (this.institutionControl.value && this.institutionControl.value.length)? this.institutionControl.value: this.selectedInstitutions;
   
        this.institutionControl.setValue(this.selectedInstitutions);
        this.updateStructure();
        if(this.lastTable == 'vca_institution') this.chargeData();
      });
    }else{
      if(isUpdate) this.lastTable = '';
      this.institutions = [];
      this.filteredInstitutions = [];
      this.institutionControl.setValue([]);
    }
    this.structures = [];
    this.cycles = [];
    this.departments = [];

    this.filteredStructures = [];
    this.filteredCycles = [];
    this.filteredDepartments = [];

    this.structureControl.setValue([]);
    this.cycleControl.setValue(null);
    this.departmentControl.setValue([]);
  }
  
  updateStructure(isUpdate:any = false){
    if(isUpdate) this.selectedInstitutions = this.institutionControl.value;
    if(this.selectedInstitutions && this.selectedInstitutions.length){
      
      let selectedInstitutions = this.selectedInstitutions.length > 1? this.selectedInstitutions: [this.selectedInstitutions[0], this.selectedInstitutions[0]];
      this.userFilter.last_table = 'vca_institution';
      this.userFilter.parent_ids = selectedInstitutions;
      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/structure', this.userFilter, this.userInfos['access_token']).subscribe((response:any)=>{
        this.structures = response;
        this.filteredStructures = this.structures;
        if(isUpdate) this.lastTable = this.userFilter.last_table;
        this.selectedStructures = (this.structureControl.value && this.structureControl.value.length)? this.structureControl.value: this.selectedStructures
        isUpdate? this.structureControl.setValue([]): this.structureControl.setValue(this.selectedStructures);
        this.updateCycle();
        if(this.lastTable == 'structure') this.chargeData();
      });
    }else{
      if(isUpdate) this.lastTable = 'country';
      this.structures = [];
      this.structureControl.setValue([]);
    }
    this.cycles = [];
    this.departments = [];

    this.filteredCycles = [];
    this.filteredDepartments = [];

    this.cycleControl.setValue(null);
    this.departmentControl.setValue([]);
  }
  updateCycle(isUpdate:boolean = false){
    if(isUpdate) this.selectedStructures = this.structureControl.value;
    
    if(this.selectedStructures && this.selectedStructures.length){
      let selectedStructures = this.selectedStructures.length > 1? this.selectedStructures: [this.selectedStructures[0], this.selectedStructures[0]];
      this.userFilter.parent_ids = selectedStructures;
      this.userFilter.last_table = 'structure';
      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/cycle', this.userFilter, this.userInfos['access_token']).subscribe((response:any)=>{
        this.cycles = response;
        this.filteredCycles = this.cycles;
        let selectedCycles = (this.cycleControl.value && this.cycleControl.value.length)? this.cycleControl.value: this.userFilter['cycle'];

        if(selectedCycles && selectedCycles.length){
          isUpdate? this.cycleControl.setValue(null): this.cycleControl.setValue(selectedCycles);
          this.updateDepartment();
        }
        
        if(this.lastTable == 'cycle') this.chargeData();
      });
    }else{
      this.cycles = [];
      this.cycleControl.setValue(null);
    }
    this.departments = [];
    this.filteredDepartments = [];
    this.departmentControl.setValue([]);
  }
  updateDepartment(isUpdate:boolean = false){
    let idCycle = this.cycleControl.value;
    let lastTable = 'cycle';
    if(isUpdate) this.selectedStructures = this.structureControl.value;
    
    if(this.selectedStructures && this.selectedStructures.length){
      let selectedStructures = this.selectedStructures.length > 1? this.selectedStructures: [this.selectedStructures[0], this.selectedStructures[0]];
      this.userFilter.last_table = lastTable;
      this.userFilter.parent_ids = selectedStructures;
      this.userFilter.id_cycle = idCycle;

      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/department', this.userFilter, this.userInfos['access_token']).subscribe((response:any)=>{
        this.departments = response;
        this.filteredDepartments = this.departments;
        if(isUpdate) this.lastTable = lastTable;
        let selectedDepartments = (this.departmentControl.value && this.departmentControl.value.length)? this.departmentControl.value: this.userFilter['department'];
        if(selectedDepartments && selectedDepartments.length){
          isUpdate? this.departmentControl.setValue([]): this.departmentControl.setValue(selectedDepartments);
        }
        if(this.lastTable == 'department') this.chargeData();
      });
    }else {
      this.departments = []; 
      this.departmentControl.setValue([]);
      if(isUpdate) this.lastTable = 'vca_institution';
    }
  }
  setDepartment(){
    this.selectedDepartments = this.departmentControl.value;
    if(this.selectedDepartments && this.selectedDepartments.length){
      this.userFilter.last_table = 'department';
      this.userFilter.parent_ids = this.selectedDepartments;
      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/save_user_navigation', this.userFilter, this.userInfos['access_token']).subscribe((response:any)=>{
        this.lastTable = 'department';
      });
    }else this.lastTable = 'structure';
  }
  setMode(){
    this.userFilter['key_mode'] = this.modeControl.value;
    this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/save_user_navigation', this.userFilter, this.userInfos['access_token']).subscribe((response:any)=>{
      });
  }

  selectedElement(selectedOptions: FormControl, element: { [x:string]: string|number|boolean }): boolean {
    return Array.isArray(selectedOptions.value) && selectedOptions.value.includes(element['id']);
  }

  chargeData() {
    if(this.lastTable){
      let value =  this.lastTable == 'country'? [this.selectedCountry, this.selectedCountry]: 
      (this.lastTable == 'vca_institution'? this.selectedInstitutions:
      (['structure', 'cycle'].includes(this.lastTable)? this.selectedStructures:
      (this.lastTable == 'department'? this.selectedDepartments: [])));
      let parentsData = {country: this.countries.filter((el:any)=> this.selectedCountry == el['id']),
                          vca_institution: this.institutions.filter((el:any)=> this.selectedInstitutions.includes(el['id'])),
                          structure: this.structures.filter((el:any)=> this.selectedStructures.includes(el['id'])),
                          department: this.departments.filter((el:any)=> this.selectedDepartments.includes(el['id']))};
        let data = {
          key: this.lastTable, value: value, mode: this.modeControl.value? this.modeControl.value: null, 
          id_cycle: this.cycleControl.value,
          search_key: this.searchControl.value,
          parents: parentsData, limit: 500, offset: 0,
          platform_infos: this.platformInfos
        };
        this.filterDataOutputEvent.emit(data);
      }else this.filterDataOutputEvent.emit({});
  }
}
